<!-- 提现款列表 coWithdrawList -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="false" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <coWithdrawAction v-if="showStatus" ref="coWithdrawAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></coWithdrawAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" ref="mainTable" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'dateTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                <span v-for="(item,index)  in JSON.parse(tableValye.formatterContent)" :key="index">
                                    <span v-if="item.key == scope.row[tableValye.entityField]">
                                        <el-tag size="mini">{{ item.value }}</el-tag>
                                    </span>
                                </span>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'comState'">{{ $common.getIsGsp(tableValye.formatterContent, scope.row.comState) }}</el-tag>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>

        <el-dialog :title="seTitle" v-if="searchDialogVisible" :visible.sync="searchDialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
import coWithdrawAction from "@/components/coWithdrawAction.vue"

export default {
    name: "coWithdrawList",
    components: {
        coWithdrawAction
    },
    data() {
        return {
            tableHeight: 0,
            getRequestData: {
                coId: '',
                coName: '',
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0,
                total: 0,
                pageNum: 0,
                list: []
            },
            buttonList: [],
            sField: '',
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            userOneList: [],
            seTitle: "",
            searchDialogVisible: false,
            seWidth: "0",
            seId: 0,
            seType: "",
            smId: "",
            showStatus: false,
            actionData: {},
            parentSearchData: {},
        };
    },
    computed: {},
    watch: {
        'getRequestData.coName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.coId = ''
                }
            },
            deep: true,
        }
    },
    methods: {
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        toDetail(orderId) {
            if (orderId) {
                var isPenetrate = true
                this.resetSetItem('penetrateOrderId', orderId);
                window.parent.postMessage({
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    }
                }, '*');
            }
        },
        openSearch(sId, index, type) {
            console.log('sId', sId,'type', type);
            this.searchDialogVisible = true;
            this.seId = sId;
            this.seType = type;
        },
        changeInputModel(val) {
            console.log('返回', this.seType, val);
            if (val != "" || val != undefined) {
                if (this.seType == 'coName') {
                    this.getRequestData.coId = val.coId
                    this.getRequestData.coName = val.coName
                }
                this.searchDialogVisible = false;
            } else {
                this.searchDialogVisible = false;
                this.$message({
                    message: "检索失败",
                    type: "error",
                });
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        addOrder() {
            this.showStatus = true
            this.actionData = {
                cate: 0,
                formData: this.formDataList,
                oldData: '',
                orderId: '',
                printSouce: '',
                printJurId: '',
                type: 'one'
            }
        },
        editOrder() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: '请先选择您要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
            this.actionData = {
                cate: 1,
                formData: this.formDataList,
                oldData: dataInfo,
                orderId: dataInfo.comId,
                printSouce: '',
                printJurId: '',
                type: 'one'
            }
            this.showStatus = true
        },
        subOrder() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: '请先选择您要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            this.$confirm('确定要提交审核吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var subData = {
                    ids: [dataInfo.comId]
                }
                let res = await this.$http.submitCargoownerMoney(subData)
                if (res.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(() => {});
        },
        delOeder() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.comId]
                }
                let res = await this.$http.deleteCargoownerMoney(delData)
                if (res.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(() => {});
        },
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.addOrder()
                    break
                case 2:
                    this.delOeder()
                    break
                case 3:
                    this.subOrder()
                    break
            }
        },
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        async getDataList() {
            let res = await this.$http.queryCargoownerMoney(this.getRequestData)
            if (res && res.status == 200) {
                let resData = JSON.parse(JSON.stringify(res))
                this.returnData.list = resData.result.list
                this.returnData.pages = resData.result.pages
                this.returnData.total = resData.result.total
                this.returnData.pageNum = resData.result.pageNum
                this.selectedDataIndex = 0
                this.$nextTick(() => {
                    this.$refs.mainTable.doLayout()
                })
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
            }
        },
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let res = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (res.status == 200) {
                this.pageShowData = res.result
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
                this.getButtonList()
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    created() {
        this.getPageInfo()
    },
    mounted() {},
    beforeCreate() {},
    beforeMount() {},
    beforeUpdate() {},
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    },
    beforeDestroy() {},
    destroyed() {},
    activated() {},
}
</script>

<style scoped>
.page_content ::v-deep .el-dialog__body {
    max-height: 94vh !important;
}

.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>
